export default {
    async checkUserHasOrders({ commit }) {
        commit("setUserHasOrderrs", true);
    },
    async getLanguagesAndCurrencies({ commit, dispatch }) {
        const requests = [
            this.$axios.get("api/languages"),
            this.$axios.get("api/countries"),
            this.$axios.get("api/rates"),
        ];
        const [langs, countries, rates] = await Promise.all(requests);
        commit("setLanguages", langs.data);
        commit("setCountries", countries.data);
        commit("setMinimumOrderPrice", rates.data);
        dispatch("setDefaults");
    },
    setDefaults({ commit, state }) {
        if (state.langs && state.countries) {
            let savedCountry = localStorage.getItem("savedCountry") || "RU";
            let savedLanguage = localStorage.getItem("savedLanguage") || "ru";

            commit("setLanguage", savedLanguage);
            this.$i18n.setLocale(savedLanguage);

            commit("setCountry", savedCountry);
        }
    },
    async getInstaPosts({ state }) {
        const res = [];
        const slides = await this.$axios.$get("/api/instagram/1");
        for (const key in slides) {
            const element = slides[key];
            res.push(element);
        }
        state.instaSlides = res;
    },
    async getMainMenu({ commit }) {
        const data = await this.$axios.$get("/api/main-menu");
        commit("setMainMenu", data);
    },
    async getBanner({ commit }) {
        const data = await this.$axios.$get("/api/template");
        commit("setBanner", data);
    },
    async getProductBlocks({ commit }) {
        // $axios.$get(`/api/product-blocks?lang=${app.i18n.locale}`)
        let data = await this.$axios.$get(`/api/product-blocks`);
        // удаляем товары без картинок
        data = data.map((block) => {
            if (!block.type) {
                block.items = Array.isArray(block.items) ? block.items.filter((el) => el.images?.length) : [];
            }
            return block;
        });

        commit("setProductBlocks", data);
    },
};
